import { render, staticRenderFns } from "./TenancyStatement.vue?vue&type=template&id=78374bf8"
import script from "./TenancyStatement.vue?vue&type=script&lang=js"
export * from "./TenancyStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports